import IUser from '../interfaces/IUser';
import { ApiConstants } from '../constants/ApiConstants';
import { buildEntityFileUrl } from './fileUrl';

const firstDefinedString = (...values: any[]) => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return '';
};

const firstDefinedValue = (...values: any[]) => {
  for (const value of values) {
    if (value !== undefined && value !== null) {
      return value;
    }
  }

  return undefined;
};

export const normalizeUser = (rawUser: any): IUser | null => {
  if (!rawUser || typeof rawUser !== 'object') {
    return null;
  }

  const userId = Number(firstDefinedValue(rawUser.id, rawUser.Id, 0));
  const companyId = Number(firstDefinedValue(rawUser.companyId, rawUser.CompanyId, 0));
  const avatar = firstDefinedString(rawUser.avatar, rawUser.Avatar) || buildEntityFileUrl(userId, ApiConstants.EntityTypes.User);
  const companyLogoUrl = firstDefinedString(
    rawUser.companyLogoUrl,
    rawUser.CompanyLogoUrl,
    rawUser.logoUrl,
    rawUser.LogoUrl,
  ) || buildEntityFileUrl(companyId, ApiConstants.EntityTypes.Company);

  return {
    ...rawUser,
    id: userId,
    roleId: Number(firstDefinedValue(rawUser.roleId, rawUser.RoleId, 0)),
    companyId,
    email: firstDefinedString(rawUser.email, rawUser.Email),
    userName: firstDefinedString(rawUser.userName, rawUser.UserName),
    firstName: firstDefinedString(rawUser.firstName, rawUser.FirstName),
    lastName: firstDefinedString(rawUser.lastName, rawUser.LastName),
    phone: firstDefinedString(rawUser.phone, rawUser.Phone),
    companyName: firstDefinedString(rawUser.companyName, rawUser.CompanyName),
    avatar,
    Avatar: avatar,
    isActive: Boolean(firstDefinedValue(rawUser.isActive, rawUser.IsActive, false)),
    activatedAt: firstDefinedValue(rawUser.activatedAt, rawUser.ActivatedAt, null),
    pageRedirect: firstDefinedValue(rawUser.pageRedirect, rawUser.PageRedirect, 2),
    companyLogoUrl,
    CompanyLogoUrl: companyLogoUrl,
    logoUrl: companyLogoUrl,
    LogoUrl: companyLogoUrl,
    password: '',
  } as IUser;
};

export default normalizeUser;
